module.exports = __webpack_public_path__ + "static/media/tryproducts.b28c56ec.png";